import { CORE_API_AKADEMIK } from '../../key/api'
import { sendMessage } from '../../../config/utils/message'

// API GET METHOD
export async function getNilai(data) {
    try {
        const response = await CORE_API_AKADEMIK.get('detail/khs?nim=' + data.nim + '&semester=' + data.semester + '&kurikulum=' + data.kurikulum)
        return response
    }
    catch (err) {
        sendMessage(500)
    }
}